import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { SLICER_KEYS } from '../../../types/services.ts';
import type { RootState } from '../../index.ts';

export type BlockerModalsState = {
  open: Record<string, boolean>;
};

const initialState: BlockerModalsState = {
  open: {},
};

export const blockerModalsState = createSlice({
  name: SLICER_KEYS.BLOCKER_MODALS_STATE,
  initialState,
  reducers: {
    openBlockerModal: (state, action: PayloadAction<{ id: string }>) => {
      state.open[action.payload.id] = true;
    },
    closeBlockerModal: (state, action: PayloadAction<{ id: string }>) => {
      state.open[action.payload.id] = false;
    },
  },
});

export const selectIsBlockerModalOpen =
  (id: string) =>
  (state: RootState): boolean =>
    Boolean(state.blockerModals?.open?.[id]);

export const { openBlockerModal, closeBlockerModal } = blockerModalsState.actions;
